import { Capacitor } from '@capacitor/core';

/**
 * Capawesome Live Update (OTA) bootstrap. Native-only — a no-op on web.
 *
 * We call ready() as early as possible so the rollback timer (readyTimeout)
 * is cleared and a bad OTA bundle can't brick the app. Automatic update checks
 * on app start/resume are handled natively via autoUpdateStrategy:'background'
 * in capacitor.config.json — new bundles download in the background and apply
 * on the NEXT launch (never mid-session), with autoBlockRolledBackBundles
 * skipping any bundle that previously failed to become ready.
 */
export async function initLiveUpdate(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { LiveUpdate } = await import('@capawesome/capacitor-live-update');
    const result = await LiveUpdate.ready();
    if (result?.rollback) {
      // eslint-disable-next-line no-console
      console.warn('[LiveUpdate] rolled back to a previous bundle after a failed update');
    }
  } catch (err) {
    // OTA wiring must never affect app startup.
    // eslint-disable-next-line no-console
    console.warn('[LiveUpdate] init skipped:', err);
  }
}
